<template>
<div id="edit-password">
  <Modal v-model="modal.visible" :title="modal.title" footer-hide>
    <IForm :key="modal.visible" ref="editPassword" label-position="top" :elem="editPasswordElem" :model="editPassword" :rules="editPasswordRule" :btn-loading="loading" :width="320" @on-submit="handleSubmit" @on-click="modal.visible = false" submit-text="保存" button button-text="取消" />
    <!-- IForm -->
  </Modal>
</div>
</template>
<script>
import { _editPwd } from "@/services/app";
export default {
  name: "EditPassword",
  data() {
    const validPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入您的新密码"));
      } else {
        if (this.editPassword.confirmPassword) {
          // 对第二个密码框单独验证
          this.$refs["editPassword"].validateField("confirmPassword");
        }
        callback();
      }
    };
    const validPwdCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入您的新密码"));
      } else {
        if (value !== this.editPassword.newPassword) {
          callback(new Error("两次输入的新密码不相同!"));
        } else {
          callback();
        }
      }
    };
    return {
      // 加载状态
      loading: false,
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      // 表单元素数组
      editPasswordElem: [
        {
          label: "原密码",
          prop: "password",
          placeholder: "请输入您原来的密码",
          type: "password"
        },
        {
          label: "新密码",
          prop: "newPassword",
          placeholder: "请输入您的新密码",
          type: "password"
        },
        {
          label: "确认新密码",
          prop: "confirmPassword",
          placeholder: "请再次输入您的新密码",
          type: "password"
        }
      ],
      // 表单数据对象
      editPassword: {
        password: "",
        newPassword : "",
        confirmPassword: ""
      },
      // 表单验证规则
      editPasswordRule: {
        password: [
          {
            required: true,
            message: "请输入你的原密码",
            trigger: "blur"
          }
        ],
        newPassword : [
          {
            required: true,
            validator: validPwd,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validPwdCheck,
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    showModal() {
      this.modal = {
        title: "密码修改页",
        visible: true
      };
      this.editPassword = {
        password: "",
        newPassword: "",
        confirmPassword : ""
      };
    },
    handleSubmit() {
      this.$Loading.start();
      this.loading = true;
      setTimeout(() => {
        _editPwd(this.editPassword)
          .then(res => {
            this.$Message.success(res.errmsg);
            this.$Loading.finish();
            this.loading = false;
            this.modal.visible = false;
          })
          .catch(() => {
            this.$Loading.error();
            this.loading = false;
          });
      }, 500);
    }
  }
};
</script>
